export const SLACK_CHAT_POST_URL: string = process.env.REACT_APP_SLACK_CHAT_POST_URL as string;
export const SLACK_CHANNEL_ID: string = process.env.REACT_APP_SLACK_CHANNEL_ID as string;
export const SLACK_BOT_TOKEN: string = process.env.REACT_APP_SLACK_BOT_TOKEN as string;
export const SLACK_LOGISTICS_PORTAL_URL = process.env.REACT_APP_LOGISTICS_PORTAL_URL as string;